package com.sweetlime.bingeamigo.presentation.features.splash

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import bingeamigo.composeapp.generated.resources.Res
import bingeamigo.composeapp.generated.resources.binge_amigo_logo
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.sweetlime.bingeamigo.repository.AuthRepository
import com.sweetlime.bingeamigo.presentation.features.auth.AuthScreen
import com.sweetlime.bingeamigo.presentation.features.auth.EmailVerificationScreen
import com.sweetlime.bingeamigo.presentation.navigation.MainScreen
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.firstOrNull
import kotlinx.coroutines.withTimeoutOrNull
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.koinInject

class SplashScreen : Screen {

    @Composable
    override fun Content() {

        val navigator =
            LocalNavigator.currentOrThrow

        val authRepository: AuthRepository =
            koinInject()

        LaunchedEffect(Unit) {
            // On the web, Firebase Auth emits null immediately before restoring the persisted
            // session from localStorage. We wait up to 3 s for a non-null user; if none arrives
            // we fall back to the first emission (null = genuinely logged out).
            val userId = withTimeoutOrNull(3_000) {
                authRepository.authStateChanged().firstOrNull { it != null }
            } ?: authRepository.authStateChanged().first()

            if (userId != null) {
                runCatching { authRepository.reloadUser() }
                if (authRepository.isEmailVerified()) {
                    navigator.replace(MainScreen)
                } else {
                    val email = authRepository.currentUserEmail() ?: ""
                    navigator.replace(EmailVerificationScreen(email))
                }
            } else {
                navigator.replace(AuthScreen())
            }
        }

        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(BrandColors.Surface),
            contentAlignment = Alignment.Center
        ) {
            Image(
                painter = painterResource(Res.drawable.binge_amigo_logo),
                contentDescription = "BingeAmigo",
                modifier = Modifier.size(200.dp)
            )
        }
    }
}